import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { UserServiceV2 } from '@app/v2/services/user-service/user.service';
import { CardMode } from '@components/card/card.component';
import { MdsCheckboxComponent } from '@medpacesoftwaredevelopment/designsystem';
import { Site } from '@models/site';
import { rxjsEffect } from '@utility/utility';
import { combineLatest, filter, tap } from 'rxjs';
import { SiteServicesPaymentValidationFormGroup } from './site-services-payment-validation.form';

@Component({
    selector: 'medpace-site-services-payment-validation',
    imports: [AsyncPipe, MdsCheckboxComponent],
    templateUrl: './site-services-payment-validation.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteServicesPaymentValidationComponent {
    userService = inject(UserServiceV2);
    elevatedAccess = this.userService.signalPermissions.site.access.elevated;
    mode = input.required<CardMode>();
    formGrp = input.required<SiteServicesPaymentValidationFormGroup>();
    formGrp$ = toObservable(this.formGrp);
    site = input<Site>();
    site$ = toObservable(this.site).pipe(filter(Boolean));

    patch$ = rxjsEffect(() =>
        combineLatest({
            site: this.site$,
            formGroup: this.formGrp$,
        }).pipe(
            tap(({ formGroup, site }) => {
                formGroup.patchValue({
                    kycDocumentationControl: site.services.kycDocumentation,
                    readyForPaymentControl: site.services.readyForPayment,
                });
            })
        )
    );

    push(site: Site) {
        const value = this.formGrp().getRawValue();
        site.services.kycDocumentation = value.kycDocumentationControl ?? false;
        site.services.readyForPayment = value.readyForPaymentControl ?? false;
        return site;
    }
}
